import { onMounted, reactive, ref, computed } from "vue";
import request from "@/utils/request.js";
import { copyToClipboard, getCompanyInfo, mediaEnu } from '@/utils/index';
import { showToast, showLoadingToast } from "vant";
import { useRoute } from "vue-router";
import useUpload from '../hook/useUpload';
let chapterTxt = null;
let ksLink = '';
export default {
  name: "agreement",
  setup() {
    let isapp = ref(window.VideoJsBridge ? true : false);
    let oslist = computed(() => storeState.getters.account_list);
    let pageData = reactive({
      bookName: "",
      receiver: "",
      task_settle_type: 1,
      admin_info: []
    });
    let mediaTask = ref({
      tg_task: null
    });
    let xtTask = reactive({
      task_id: ''
    });
    const pageQuery = useRoute().query;
    let {
      startShare,
      dyShareMsg,
      initUpload,
      dyShareOver,
      isFile,
      openDyUrl
    } = useUpload();
    let book_id = "";
    let showPop = ref(false);
    // let askTab = ref(isDyxt ? 'dyxt' : 'mount')
    let askTab = ref('mount');
    let mediaType = ref('');

    // 渠道创建推广
    let isShow = ref(false);
    let upshow = ref(false);
    let sheetShow = ref(false);
    let name = ref(''); // 推广名称
    let bookId = ref(''); // 推广剧名ID
    let chapterIdx = ref('1'); // 推广剧集序号
    let company_type = ref('');
    let isOver = ref(false);

    // -----
    let tname = ref(''); // 推广名称
    let appid = ref(''); // 推广名称
    let path = ref(''); // 推广名称
    onMounted(() => {
      if (!pageQuery.book_id) {
        showToast("初始化数据失败，缺少必要参数");
        return false;
      }
      chapterTxt = null;
      book_id = pageQuery.book_id;
      company_type.value = pageQuery.company_type;
      getBookInfo();
    });

    /**
     * @description: 获取书籍信息
     * @return {*}
     */
    const getBookInfo = () => {
      request.post("/v1/Koc/bookinfov1", {
        book_id,
        company_type: pageQuery.company_type
      }).then(res => {
        if (!res) return;
        for (const key in res) {
          if (Object.hasOwnProperty.call(res, key)) pageData[key] = res[key];
        }
        const adminInfo = res.admin_info || [];
        if (adminInfo.length) {
          var _mediaTask$value$tg_t, _mediaTask$value$xt_t;
          mediaType.value = adminInfo[0].media;
          mediaTask.value = adminInfo[0];
          if ((_mediaTask$value$tg_t = mediaTask.value.tg_task) !== null && _mediaTask$value$tg_t !== void 0 && _mediaTask$value$tg_t.task_id) {
            askTab.value = 'mount';
          } else if ((_mediaTask$value$xt_t = mediaTask.value.xt_task) !== null && _mediaTask$value$xt_t !== void 0 && _mediaTask$value$xt_t.task_id) {
            askTab.value = 'chart';
          } else {
            askTab.value = 'mix';
          }
          if (adminInfo[0].xt_task) {
            for (const key in adminInfo[0].xt_task) {
              if (Object.hasOwnProperty.call(adminInfo[0].xt_task, key)) xtTask[key] = adminInfo[0].xt_task[key];
            }
          }
        }
        if (pageData.net_disk) pageData.pwd = pageData.net_disk.split("pwd=")[1];
      }).finally(() => {
        isOver.value = true;
      });
    };

    /**
     * @description: 百度云网盘
     * @return {*}
     */
    const getContext = () => {
      if (pageData.net_disk) window.location.href = pageData.net_disk;
    };

    // 创建推广开始
    const referralFn = type => {
      if (type == 'tg' && mediaTask.value.tg_task.web_link) {
        window.location.href = mediaTask.value.tg_task.web_link;
        request.post("/v1/Koc/create_video");
      }
      if (type == 'cj') {
        isShow.value = true;
      }
    };

    // 推广确认
    const confirm = () => {
      if (!pageData.bookId) {
        showToast('缺少书籍信息');
        return;
      }
      if (!name.value) {
        showToast('请输入名称');
        return;
      }
      if (!chapterIdx.value) {
        showToast('请输入剧集序号');
        return;
      }
      if (!/^[1-9]+[0-9]*$/.test(chapterIdx.value)) {
        showToast('请输入正整数');
        return;
      }
      if (!mediaType.value) {
        showToast('请选择平台类型');
        return;
      }
      const params = {
        bookId: pageData.bookId,
        name: name.value,
        chapterIdx: chapterIdx.value,
        media: mediaType.value,
        company_type: pageData.company_type || ''
      };
      request.post('/v1/Koc/referralsave', params).then(res => {
        if (res && res.referralId) {
          isShow.value = false;
          chapterIdx.value = '1';
          name.value = '';
          showToast("\u521B\u5EFA\u6210\u529F\uFF0C\u8BF7\u5728\u300C\u63A8\u5E7F\u300D\u76F8\u5E94\u9875\u9762\u67E5\u770B");
          const jsBridge = window.VideoJsBridge;
          if (jsBridge) {
            if (res.media == 'dy') {
              jsBridge.share(res.appid, res.name, res.path, 'shareCallbak');
            }
            if (res.media == 'ks') {
              showLoadingToast({
                message: '拉起小程序中...'
              });
              setTimeout(() => {
                jsBridge.open_link(mediaEnu.ks, res.appid, encodeURIComponent(res.path));
              }, 1000);
            }
          } else {
            // h5分享 抖音分享挂载
            if (res.media == 'dy') {
              // showToast('创建成功')
              upshow.value = true;
              isShow.value = false;
              startShare(res);
              nextTick(() => {
                initUpload();
              });
            }
            if (res.media == 'ks') {
              ksLink = "://miniapp?appId=".concat(res.appid, "&path=").concat(encodeURIComponent(res.path));
              sheetShow.value = true;
            }
          }
        }
      });
    };

    // const base64ToBlob = (code) => {
    //   let parts = code.split(";base64,");
    //   let contentType = parts[0].split(":")[1];
    //   let raw = window.atob(parts[1]);
    //   let rawLength = raw.length;
    //   let uInt8Array = new Uint8Array(rawLength);
    //   for (let i = 0; i < rawLength; ++i) {
    //     uInt8Array[i] = raw.charCodeAt(i);
    //   }
    //   return new window.Blob([uInt8Array], { type: contentType });
    // };

    // const downloadCover= (url)=> {
    // 	url = url // 'https://video-admin.cps24.dzods.cn/uploads/20231114/5dcc40bf9e5202ea9c0bc863accbd4b1.png'
    // 	console.log('保存当前的地址',url)
    // 	const canvas = document.createElement('canvas');
    // 	var ctx = canvas.getContext("2d")
    // 	ctx.canvas.width = 375
    // 	ctx.canvas.height =749

    // 	var img = new Image()
    // 	img.setAttribute('crossOrigin', 'anonymous');
    // 	img.src= url

    // 	img.onload = function(e) {
    // 		console.log('当前加载完成', e)
    // 		// ctx.clearRect(0,0,300,300)
    // 		ctx.drawImage(img, 0,0, 375,749)
    // 		ctx.save()

    // 		let base64 = canvas.toDataURL("image/jpeg", 1);

    // 		let a = document.querySelector('#temp-dowload');
    // 		a.download = `${new Date().valueOf()}.jpeg`;
    // 		// 创建二进制对象
    // 		const downloadURL = (window.URL || window.webkitURL).createObjectURL(base64ToBlob(base64));
    // 		a.href = downloadURL;
    // 		// 模拟点击
    // 		a.click();

    // 	}
    // }

    /**
     * @description: 下载封面图片
     * @param {*} url
     * @return {*}
     */
    const downloadCover = url => {
      if (window.VideoJsBridge) {
        window.VideoJsBridge.downloadImage(url);
      } else {
        showToast('请在天天悦读APP内操作');
      }
    };

    /**
     * @description: 切换底部tab
     * @param {*} type
     * @return {*}
     */
    const changeTab = type => {
      askTab.value = type;
    };

    /**
     * @description: 切换底部媒体列表
     * @param {*} data
     * @return {*}
     */
    const changeMedia = function () {
      var _data$tg_task, _data$xt_task, _data$rh_task;
      let data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      if (data.media == mediaType.value) return false;
      mediaType.value = data.media;
      mediaTask.value = data;
      if ((_data$tg_task = data.tg_task) !== null && _data$tg_task !== void 0 && _data$tg_task.task_id) {
        askTab.value = 'mount';
      } else if ((_data$xt_task = data.xt_task) !== null && _data$xt_task !== void 0 && _data$xt_task.task_id) {
        askTab.value = 'chart';
      } else if ((_data$rh_task = data.rh_task) !== null && _data$rh_task !== void 0 && _data$rh_task.task_id) {
        askTab.value = 'mix';
      } else {
        xtTask.task_id = '';
        askTab.value = '';
      }
      if (data.xt_task) {
        for (const key in data.xt_task) {
          if (Object.hasOwnProperty.call(data.xt_task, key)) xtTask[key] = data.xt_task[key];
        }
      }
    };

    /**
     * @description: 打开任务详情
     * @return {*}
     */
    const openUrl = () => {
      if (xtTask.task_url) window.location.href = xtTask.task_url;
    };

    /**
    * @description: 快手版本选择
    * @param {*} data
    * @return {*}
    */
    const selectSheet = data => {
      window.location.href = data.value + ksLink;
      ksLink = '';
    };
    const openDyApp = webUrl => {
      if (webUrl) {
        window.open(webUrl);
      } else {
        showToast("暂无任务地址");
      }
    };
    const confirmAction = () => {
      console.log('手动参数', appid.value, tname.value, path.value);
      if (window.VideoJsBridge) {
        window.VideoJsBridge && window.VideoJsBridge.share(appid.value, tname.value, path.value, 'shareCallbak');
      }
    };
    return {
      isapp,
      pageData,
      xtTask,
      bookId,
      mediaType,
      showPop,
      askTab,
      isShow,
      upshow,
      sheetShow,
      name,
      chapterIdx,
      company_type,
      mediaEnu,
      mediaTask,
      isOver,
      appid,
      tname,
      path,
      copyToClipboard,
      downloadCover,
      referralFn,
      confirm,
      getContext,
      changeTab,
      changeMedia,
      openUrl,
      startShare,
      dyShareMsg,
      initUpload,
      dyShareOver,
      isFile,
      openDyUrl,
      getCompanyInfo,
      selectSheet,
      openDyApp,
      confirmAction
    };
  }
};